export const getSessionId = () => {
  try {
    let id = localStorage.getItem("hhas_sid");
    if (!id) {
      id =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        `sid-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("hhas_sid", id);
    }
    return id;
  } catch (e) {
    return `anon-${Math.random().toString(36).slice(2)}`;
  }
};
